import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

const FACTS = [
  { label: "Standort", value: "Köln, Deutschland" },
  { label: "Fokus", value: "Smartphones, KI, Technik" },
  { label: "Jahrgang", value: "Digital Native" },
];

/**
 * About – short personal statement combined with a compact fact grid.
 */
export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative px-6 py-28 sm:px-10 sm:py-36 md:px-16 lg:px-24"
    >
      <div className="mx-auto mb-20 h-px w-full max-w-5xl bg-gradient-to-r from-transparent via-white/[0.08] to-transparent" />

      <div className="mx-auto grid w-full max-w-5xl gap-16 md:grid-cols-12">
        <motion.aside
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease }}
          className="md:col-span-4"
        >
          <p className="font-mono-label text-xs text-zinc-500">
            <span className="mr-3 text-[#FF4500]">01</span> Über mich
          </p>

          <ul className="mt-10 space-y-6" data-testid="about-facts">
            {FACTS.map((f) => (
              <li key={f.label} className="border-l border-white/[0.06] pl-4">
                <p className="font-mono-label text-[10px] text-zinc-600">
                  {f.label}
                </p>
                <p className="mt-1 text-sm text-zinc-300">{f.value}</p>
              </li>
            ))}
          </ul>
        </motion.aside>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease, delay: 0.1 }}
          className="md:col-span-8"
        >
          <h2
            className="font-display text-3xl font-bold leading-[1.05] tracking-tight text-[#FAFAFA] sm:text-4xl md:text-5xl lg:text-6xl"
            data-testid="about-headline"
          >
            Reparieren.
            <br />
            <span className="text-zinc-500">Verstehen. Bauen.</span>
          </h2>

          <div
            className="mt-10 space-y-6 text-lg leading-relaxed text-zinc-400 sm:text-xl"
            data-testid="about-copy"
          >
            <p>
              Tagsüber schraube ich Smartphones auseinander, wechsle
              Displays, Akkus und alles, was dazwischen kaputtgeht. Was
              ich daran liebe: am Ende funktioniert wieder etwas.
            </p>
            <p>
              Nebenbei bin ich hoffnungslos neugierig auf alles Digitale –
              KI, neue Tools, moderne Software. Ich baue kleine eigene
              Projekte, nicht um sie zu verkaufen, sondern um zu
              verstehen, wie sie funktionieren.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
